module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/chair/chair.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/chair/chair.png
// module id = 532
// module chunks = 0